import React, { useEffect, useState } from "react";
import MuiDialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/styles";
import { CoachingCloseReasonOptions } from "../../../enums/CoachingCloseReason";

const Dialog = withStyles({
  paper: {
    maxWidth: 500,
    width: "100%",
    borderRadius: 14,
  },
})(MuiDialog);

// Close confirmation that also collects WHY the coaching is closed — the
// backend decides from it whether the coach is paid, so a reason is required.
export default function CloseCoachingDialog({ coaching, onConfirm, onClose }) {
  const [reason, setReason] = useState(null);

  // Fresh choice for every record; never carry a reason over.
  useEffect(() => {
    setReason(null);
  }, [coaching]);

  return (
    <Dialog open={!!coaching} onClose={onClose}>
      <div className="uc-dialog">
        <h3 className="uc-dialog-title">Koçluğu Kapat</h3>
        <p className="uc-dialog-subtitle">
          {coaching
            ? `${coaching.CoachName || "Koç"} ile olan koçluk kaydı (ID: ${coaching.Id}) kapatılacak. Kullanıcının okul-koç eşleşmesi de kaldırılır. Lütfen kapatma nedenini seçiniz.`
            : ""}
        </p>

        <div className="uc-reason-list" role="radiogroup">
          {CoachingCloseReasonOptions.map((opt) => (
            <label
              key={opt.value}
              className={
                "uc-reason-option " + (reason === opt.value ? "active" : "")
              }
            >
              <input
                type="radio"
                name="uc-close-reason"
                value={opt.value}
                checked={reason === opt.value}
                onChange={() => setReason(opt.value)}
              />
              <span className="uc-reason-text">
                <span className="uc-reason-label">{opt.label}</span>
                <span className="uc-muted">{opt.description}</span>
              </span>
            </label>
          ))}
        </div>

        <div className="uc-dialog-actions">
          <button
            type="button"
            className="uc-btn uc-btn-secondary"
            onClick={onClose}
          >
            Vazgeç
          </button>
          <button
            type="button"
            className="uc-btn uc-btn-danger-solid"
            onClick={() => onConfirm(reason)}
            disabled={reason === null}
          >
            Koçluğu Kapat
          </button>
        </div>
      </div>
    </Dialog>
  );
}
